import { useState, useCallback, useMemo } from 'react';
import fileShouldRender from './fieldShouldRender';

function useDynamicFormikFetchingApi(config, record) {
  const fetchingStore = {};

  config.fields
    .filter(field => field.needsFetch && fileShouldRender(field, record))
    .forEach(field => {
      fetchingStore[field.id] = { fetching: true, error: false };
    });

  const [fetchingState, setFetchingState] = useState(fetchingStore);

  const onFetchingComplete = useCallback(
    id =>
      setFetchingState(prevFetchingState => {
        const newFetchingState = { ...prevFetchingState };
        newFetchingState[id].fetching = false;
        return newFetchingState;
      }),
    []
  );

  const onFetchingError = useCallback(
    id =>
      setFetchingState(prevFetchingState => {
        const newFetchingState = { ...prevFetchingState };
        newFetchingState[id].fetching = false;
        newFetchingState[id].error = true;
        return newFetchingState;
      }),
    []
  );

  const getFetchingApi = useMemo(() => ({ onFetchingComplete, onFetchingError }), [
    onFetchingComplete,
    onFetchingError
  ]);

  return [fetchingState, getFetchingApi];
}

export default useDynamicFormikFetchingApi;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/dynamic_forms/useDynamicFormikFetchingApi.js